import {
  ICS204_PREPARED_BY_SIGN_ROLE,
  formatSignatureCompletionStatus,
  formatSignatureDateTime,
  formatSignatureDraftLabel,
  parseWalaSignatures,
  type SignatureCompletionStatus,
  type SignatureSlot,
  type WalaSignature,
} from '../AssignmentList/ics204SignatureSlots';

export type Ics215Signature = WalaSignature;

export {
  ICS204_PREPARED_BY_SIGN_ROLE,
  formatSignatureCompletionStatus,
  formatSignatureDateTime,
  formatSignatureDraftLabel,
  parseWalaSignatures,
};
export type { SignatureCompletionStatus, SignatureSlot };

/** ICS-215 Box 15 — Prepared By only. */
export const ICS215_REQUIRED_SIGNATURE_SLOTS: SignatureSlot[] = [
  {
    id: 'prepared-by',
    label: 'Prepared By',
    boxLabel: '15. Prepared By',
    role: ICS204_PREPARED_BY_SIGN_ROLE,
    isComplete: (signatures) => signatures.length > 0 && signatures[0] != null,
    findSignature: (signatures) => signatures[0],
  },
];

export function getIcs215SignatureCompletion(
  signatures: Ics215Signature[] | null | undefined
): {
  status: SignatureCompletionStatus;
  completedCount: number;
  requiredTotal: number;
  percent: number;
  slots: Array<
    SignatureSlot & { complete: boolean; signature?: Ics215Signature }
  >;
} {
  const safeSignatures = signatures ?? [];
  const requiredTotal = ICS215_REQUIRED_SIGNATURE_SLOTS.length;
  const slots = ICS215_REQUIRED_SIGNATURE_SLOTS.map((slot) => ({
    ...slot,
    complete: slot.isComplete(safeSignatures),
    signature: slot.findSignature(safeSignatures),
  }));
  const completedCount = slots.filter((slot) => slot.complete).length;

  let status: SignatureCompletionStatus = 'draft';
  if (safeSignatures.length === 0 || completedCount === 0) {
    status = 'draft';
  } else if (completedCount >= requiredTotal) {
    status = 'signed';
  } else {
    status = 'partially-signed';
  }

  return {
    status,
    completedCount: Math.min(completedCount, requiredTotal),
    requiredTotal,
    percent:
      requiredTotal === 0
        ? 0
        : Math.round(
            (Math.min(completedCount, requiredTotal) / requiredTotal) * 100
          ),
    slots,
  };
}

export function isIcs215VersionLocked(
  signatures: Ics215Signature[] | null | undefined
): boolean {
  return getIcs215SignatureCompletion(signatures).status !== 'draft';
}
